import {createSlice, PayloadAction} from '@reduxjs/toolkit';

import {PageRevision} from '~shared/models/wiki';

import {getRevisions} from './thunks';

export interface RevisionsState {
    entities: Record<PageRevision['id'], PageRevision>;
    loading?: boolean;
    error?: boolean;
}

const initialState: RevisionsState = {
    loading: false,
    error: false,
    entities: {},
};

interface ResetPayload {
    pageId: number;
}

const setRevisionsDetails = (state: RevisionsState, revision: PageRevision) => {
    state.entities[revision.id] = Object.assign({}, state.entities[revision.id], revision);
};

const {reducer, actions} = createSlice({
    name: 'revisions',
    initialState,
    reducers: {
        reset(_state, _action: PayloadAction<ResetPayload>) {
            return initialState;
        },
    },
    extraReducers: (builder) =>
        builder
            .addCase(getRevisions.pending, (state) => {
                state.loading = true;
                state.error = false;
            })
            .addCase(getRevisions.fulfilled, (state, {payload}) => {
                payload.results.forEach((revision) => {
                    setRevisionsDetails(state, revision);
                });

                state.loading = false;
            })
            .addCase(getRevisions.rejected, (state) => {
                state.loading = false;
                state.error = true;
            }),
});

export {actions, reducer};
